"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var styled_components_1 = __importDefault(require("styled-components"));

exports.DescriptionParagraph = styled_components_1.default(components_lib_1.Paragraph)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    max-width: 350px;\n    margin-bottom: 20px;\n"], ["\n    max-width: 350px;\n    margin-bottom: 20px;\n"])));
var templateObject_1;